import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  FormHelperText,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Link,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Typography,
  Avatar,
  Badge,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Stack } from "@mui/system";
import Switch from "@mui/material/Switch";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import { useDispatch, useSelector } from "react-redux";
import { createChallengeAction } from "../../redux/toolkit/challenge/createChallenge";
import { uplodImageAction } from "../../redux/toolkit/image/uplodImage";
import { createLifeLineAction } from "../../redux/toolkit/lifeLine/createLifeLine";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>

      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/allLifeline"
      >
        All Lifeline
      </Link>

      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/createLifeLine"
      >
        Create Lifeline
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Create Lifeline
    </Typography>
  </Stack>
);

const qns_ans_schema = yup
  .object()
  .shape({
    description: yup.string().required("Description Is Required."),
    image: yup.string().required("Duration Is Required..."),
  })
  .required();

const CreateLifeLine = () => {
  const dispatch = useDispatch();
  const [snack, setSnack] = useState(false);
  const [active, setIsActive] = useState(false);
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [lineLine, setLifeLine] = useState("");
  const [description , setDescription] = useState("")

   const { createLifeLine: data, loading } = useSelector(
      (state) => state.createLifeLine
    );


  const {
    register,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(qns_ans_schema),
    defaultValues: {},
  });

  const handleQns = async (data) => {
    let lifelineInfo = {
      description:description,
      active: active,
      icon:image ,
      name:lineLine
    };

    const createChallengeData = await dispatch(
      createLifeLineAction(lifelineInfo)
    );
    setSnack(true);
    if (createChallengeData?.payload?.status == 201) {
      reset();
      setTimeout(() => {
        navigate("/allLifeLine");
      }, 1500);
    }

    setSnack(true);
    // setState(false)
  };

  const handleSwitchChange = () => {
    setIsActive(!active);
  };

  const handleImage = async (e) => {
    const formData = new FormData();
    const file = e.target.files[0];
    formData.append("file", file);

    let FileSize = Number(e.target.files[0].size / 1000);

    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;

    img.onload = async function () {
      // console.log(img, file);
      width = this.width;
      height = this.height;
      if (FileSize > 5000) {
        return alert(
          `Image should be to under 50kb reupload image, Your file size is ${FileSize}`
        );
      }
      // if (height > 120 && width > 400) {
      //   // console.log(formData);
      //   let uploadedImg = await dispatch(uplodImageAction(formData));
      //   const imgStr = uploadedImg?.payload?.data?.url;
      //   setImage(uploadedImg?.payload?.data?.url);
      //   setValue("image", imgStr);
      //   alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
      // } else {
      //   alert(
      //     `Image height less then 150 & greater then 120 width less then 420 & greater then 400, Your height=${height} & width=${width}`
      //   );
      // }
        let uploadedImg = await dispatch(uplodImageAction(formData));
        const imgStr = uploadedImg?.payload?.data?.url;
        setImage(uploadedImg?.payload?.data?.url);
        setValue("image", imgStr);
        alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };

  const handleClose = function () {
    reset();
    navigate("/allLifeLine");
  };


  const handleChange = (event) => {
    setLifeLine(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title> Create Life Line</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Card sx={{ p: 5 }}>
          <Typography variant="h5" sx={{ mb: 5 }}>
            Add LifeLine
          </Typography>
          <form onSubmit={handleSubmit(handleQns)}>
            <Stack spacing={3}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    LifeLine Name
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={lineLine}
                    label="Age"
                    onChange={handleChange}
                  >
                    <MenuItem value={"50-50"}>50-50</MenuItem>
                    <MenuItem value={"audience_poll"}>audience_poll</MenuItem>
                    <MenuItem value={"flip_question"}>flip_question</MenuItem>
                    <MenuItem value={"time_freeze"}>time_freeze</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Stack direction="row" spacing={10}>
                <TextField
                  label="description"
                  value={description}
                  onChange={(e)=>{
                    setDescription(e.target.value)
                  }}
                  style={{ width: "450px" }}
                />
              </Stack>

              <Stack direction="row" spacing={10}>
                <FormControlLabel
                  control={
                    <Switch onChange={handleSwitchChange} checked={active} />
                  }
                  label="Is Active"
                />
              </Stack>

              <TextField
                type="file"
                accept="image/*"
                variant="outlined"
                id="image-upload"
                placeholder="image"
                onChange={handleImage}
                error={errors?.image?.message}
                helperText={errors?.image?.message}
              />
              <Badge anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <Avatar src={image} sx={{ width: 100 }} />
              </Badge>

              <Stack direction="row" spacing={2}>
                <Button variant="contained" type="submit" disabled={loading} onClick={()=>handleQns()}>
                  {loading ? <CircularProgress /> : "Create LineLine"}
                </Button>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Back
                </Button>
              </Stack>
            </Stack>
          </form>
        </Card>
      </Body>
    </>
  );
};

export default CreateLifeLine;
